import Stars from "@/components/base/Stars";
import {
  currentStore,
  dashboardStats,
  dashboardTrends,
} from "@/mocks/dashboard";
import { formatNumber } from "@/utils/format";
import StatCard from "./StatCard";

export default function StatCards() {
  const stats = dashboardStats;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      <StatCard
        label="طلبات اليوم"
        icon="ri-shopping-bag-3-line"
        iconClass="bg-accent-100 text-accent-700"
        caption="مقارنة بالأمس"
        trend={dashboardTrends.orders}
      >
        <p className="mt-2 text-[32px] font-bold leading-none text-foreground-950">
          {formatNumber(stats.todayOrders)}
        </p>
        <p className="mt-2 text-xs text-foreground-400">
          إجمالي الطلبات المستلمة
        </p>
      </StatCard>

      <StatCard
        label="مبيعات اليوم"
        icon="ri-money-dollar-circle-line"
        iconClass="bg-primary-100 text-primary-700"
        caption="مقارنة بالأمس"
        trend={dashboardTrends.sales}
      >
        <p className="mt-2 flex items-baseline gap-1.5 whitespace-nowrap text-[26px] xl:text-[28px] font-bold leading-none text-foreground-950">
          {formatNumber(stats.todaySales)}
          <span className="text-sm font-semibold text-foreground-400">
            ر.س
          </span>
        </p>
        <p className="mt-2 text-xs text-foreground-400">
          إجمالي المبيعات المحصّلة
        </p>
      </StatCard>

      <StatCard
        label="الطلبات النشطة"
        icon="ri-flashlight-line"
        iconClass="bg-accent-100 text-accent-700"
        caption="مقارنة بالأمس"
        trend={dashboardTrends.activeOrders}
      >
        <p className="mt-2 text-[32px] font-bold leading-none text-foreground-950">
          {stats.activeOrders}
        </p>
        <p className="mt-2 text-xs text-foreground-400">
          قيد التحضير والاستلام
        </p>
      </StatCard>

      <StatCard
        label="التقييم العام"
        icon="ri-star-line"
        iconClass="bg-primary-100 text-primary-700"
        caption="مقارنة بالشهر الماضي"
        trend={dashboardTrends.rating}
      >
        <p className="mt-2 text-[32px] font-bold leading-none text-foreground-950">
          {currentStore.rating}
        </p>
        <div className="mt-2 flex items-center gap-2">
          <Stars value={currentStore.rating} />
          <span className="text-xs text-foreground-400">
            ({formatNumber(currentStore.ratingCount)} تقييم)
          </span>
        </div>
      </StatCard>
    </div>
  );
}